import { clowncar, core } from 'types';
import ClowncarAppConstants from 'constants/ClowncarAppConstants';

export function fetchAll(): ApiAction {
  return {
    TockApi: {
      getListProto: '/internal/business/verification',
      type: ClowncarAppConstants.VERIFICATIONS_REQUIRED,
    },
  };
}

export function uploadEvidence(verification: clowncar.BusinessVerification, file: File): ApiAction {
  return {
    TockApi: {
      postFile: `/internal/business/verification/upload/${verification.id}`,
      request: file,
      type: ClowncarAppConstants.VERIFICATION_EVIDENCE_UPLOAD,
      toast: 'Evidence uploaded',
    },
  };
}

export function getEvidenceUrl(verification: clowncar.BusinessVerification): ApiAction {
  return {
    TockApi: {
      getProto: `/internal/business/verification/${verification.id}/evidence`,
      type: ClowncarAppConstants.VERIFICATION_EVIDENCE_URL,
    },
  };
}

export function getReports(verification: clowncar.BusinessVerification): ApiAction {
  return {
    TockApi: {
      getProto: `/internal/business/verification/${verification.id}/reports`,
      type: ClowncarAppConstants.VERIFICATION_REPORTS,
    },
  };
}

export function acceptEvidence(business: core.Business): ApiAction {
  return {
    TockApi: {
      postProto: `/internal/business/verification/verify/${business.id}`,
      type: ClowncarAppConstants.VERIFICATION_ACCEPT_EVIDENCE,
      toast: 'Business Verified',
    },
  };
}
